module.exports = "/images/vendor/flag-icon-css/flags/1x1/th.svg?904dd7853b623153a82acf5c4abd297b";